import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { matchMediaQueries } from 'builder/utils/matchMediaQueries'

export const HEADER_HEIGHTS = {
  desktop: 72,
  tablet: 64,
  mobile: 56,
}

export const getAutotailoringHeaderHeight = (
  mediaQueries: ReturnType<typeof matchMediaQueries>,
) => {
  const { isTablet, isPhone } = mediaQueries
  if (isPhone) {
    return HEADER_HEIGHTS.mobile
  }
  if (isTablet) {
    return HEADER_HEIGHTS.tablet
  }
  return HEADER_HEIGHTS.desktop
}

export const Container = styled.div`
  height: ${HEADER_HEIGHTS.desktop}px;
  background-color: ${Colors.White};
  border-bottom: 1px solid ${Colors.Neutral15};
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  padding: 0 32px;
  align-items: center;

  ${Media.Tablet`
    height: ${HEADER_HEIGHTS.tablet}px;
  `}

  ${Media.Phone`
    height: ${HEADER_HEIGHTS.mobile}px;
  `}
`

export const BackIcon = styled.div`
  z-index: 1;
  cursor: pointer;
  color: ${Colors.Neutral50};
  transform: rotate(180deg);
`
export const Center = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const Title = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral90};
`

export const Step = styled.div`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const WrapperStartTailoringButton = styled.div`
  margin: 12px 0;
  display: flex;
  gap: ${Spacing.S};

  ${Media.Tablet`
    display: none;
  `}
`
